import React from "react";
import Link from "next/link";
import { Form } from "formik";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import SpinnerButton from "@packages/common/src/components/form/SpinnerButton";

import TermsAndPrivacyText from "../../../common/components/form/auth/TermsAndPrivacyText";
import RenderFormFields from "../common/RenderFormFields";
import { IFormFieldItem } from "../accountsTypes";
import { useRouter } from "next/router";

const SignUpBase: React.FC<{
  signupFormFields: IFormFieldItem[];
  isSubmitting: boolean;
  buttonText?: string;
}> = ({ signupFormFields, isSubmitting, buttonText = "Sign Up" }) => {
  const router = useRouter();

  return (
    <Form>
      <RenderFormFields fields={signupFormFields} />
      <Box sx={{ textAlign: "start" }}>
        <TermsAndPrivacyText
          startText="By signing up, you agree to our"
          typographySxProps={{ py: 4, color: "text.primary" }}
        />
      </Box>
      <SpinnerButton type="submit" disabled={isSubmitting}>
        {buttonText}
      </SpinnerButton>
      <Typography pt={6} variant="body2">
        Already have an account?{" "}
        <Link
          href={`/accounts/login${
            router.query?.next ? `?next=${router.query.next}` : ""
          }`}
          passHref
        >
          <Typography
            variant="body2"
            component="strong"
            sx={{ fontWeight: 700, cursor: "pointer" }}
          >
            Log In
          </Typography>
        </Link>
      </Typography>
    </Form>
  );
};

export default SignUpBase;
